import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import Image from 'next/image';

import { atiDriverApp } from 'constants/pages';
import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import css from './Promo.module.css';

const Promo = () => {
  const {
    mobileDevices,
    app: { i18n, env },
  } = useStore();

  const HasApps = (
    <>
      <div className={css.promoBackGround} />

      <div className={css.promo}>
        <div className={css.apps}>
          <div className={css.info}>
            <div className={cn(css.appIcon, css.appIcon_big)}>
              <Image
                alt={i18n.filterPopup.appIconAlt}
                height={40}
                layout="fixed"
                src={interpolate(atiDriverApp.appIconSrc, { env })}
                style={{ flexShrink: 0, marginRight: 15 }}
                width={40}
              />
            </div>
            <div className={css.description}>
              <span>{i18n.filterPopup.notificationsToAllApps}</span>
              &nbsp;
              <strong>{i18n.filterPopup.notifiableApps}</strong>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const DownloadApp = (
    <>
      <div className={css.promoBackGround} />

      <div className={css.promo}>
        <div className={css.promoTitle}>{i18n.filterPopup.promoTitle}</div>

        <div className={css.apps}>
          <div className={css.info}>
            <div className={css.appIcon}>
              <Image
                alt={i18n.filterPopup.appIconAlt}
                height={30}
                src={interpolate(atiDriverApp.appIconSrc, { env })}
                width={30}
              />
            </div>
            <div>
              <div className={css.appName}>
                <strong>{i18n.filterPopup.appName}</strong>
              </div>
              <div className={css.description}>{i18n.filterPopup.appDescription}</div>
            </div>
          </div>

          <div className={css.downloadLinks}>
            <div>
              <a href={atiDriverApp.android.href} rel="noreferrer" target="_blank">
                <Image
                  alt={i18n.filterPopup.playMarketIconAlt}
                  height={30}
                  src={interpolate(atiDriverApp.android.imgSrc, { env })}
                  width={94}
                />
              </a>
            </div>
            <div>
              <a href={atiDriverApp.ios.href} rel="noreferrer" target="_blank">
                <Image
                  alt={i18n.filterPopup.appStoreIconAlt}
                  height={30}
                  src={interpolate(atiDriverApp.ios.imgSrc, { env })}
                  width={94}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return mobileDevices.availableDevices?.availableChannels.length ? HasApps : DownloadApp;
};

const connected = observer(Promo);

export { connected as Promo };
